;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('publicLink', publicLink)

  function publicLink () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        art: '<',
        buttons: '=',
        sending: '='
      },
      templateUrl: '/arts/directives/public-link/public-link-directive.html?$$REVISION$$',
      controller: 'PublicLinkController'
    }
  }
})()
